import Joi from "joi";

export type EmailVerifiedDto = { emailVerified: boolean };
export const emailVerifiedResponseSchema = Joi.object<EmailVerifiedDto>({
  emailVerified: Joi.boolean().required(),
}).unknown();
